import * as React from 'react'
import { Swiper, SwiperSlide } from 'swiper/react'
import 'swiper/css'
import 'swiper/css/navigation'
import 'swiper/css/pagination'
import 'swiper/css/effect-fade'
import SwiperCore, { Navigation, Pagination, Autoplay, EffectFade } from 'swiper'

SwiperCore.use([Navigation, Pagination, Autoplay, EffectFade]);

// Üks <picture> mobiili + desktopi pildi jaoks: brauser laeb ainult sobiva variandi
// (varem oli kaks <img>-i, millest peidetud laaditi samuti alla).
const SlideImage = ({ item, eager }) => (
    <picture>
        {item.image_mobile && (
            <source
                media="(max-width: 767px)"
                srcSet={item.image_mobile_srcset || item.image_mobile}
                sizes="100vw"
                width={item.image_mobile_width || undefined}
                height={item.image_mobile_height || undefined}
            />
        )}
        <img
            src={item.image}
            srcSet={item.image_srcset || undefined}
            sizes={item.image_srcset ? '100vw' : undefined}
            width={item.image_width || undefined}
            height={item.image_height || undefined}
            alt={item.title}
            loading={eager ? 'eager' : 'lazy'}
            fetchpriority={eager ? 'high' : undefined}
            decoding="async"
            className="absolute inset-0 w-full h-full object-cover"
        />
    </picture>
);

const Slider = ({ items }) => {
    return (
        <Swiper className="mySwiper h-[500px] lg:h-[850px]"
            modules={[EffectFade]}
            effect="fade"
            pagination={{ clickable: true }}
            autoplay={{ delay: 5000, disableOnInteraction: false }}
            speed={1000}
            loop={true}>
            {items.map((item, index) => (
                <SwiperSlide key={index} className="relative overflow-hidden">
                    <SlideImage item={item} eager={index === 0} />
                    <div className="absolute inset-0 flex flex-col justify-center items-center z-10 bg-black/20">
                        <div className="container mx-auto text-center text-white px-4">
                            <h1 className="mb-6 text-h3 lg:text-hero font-bold" style={{ textShadow: '1px 1px 4px rgba(0,0,0,0.8)' }}>
                                {item.title}
                            </h1>
                            <p className="mb-14 text-basic lg:text-h3 min-h-8">
                                {item.description}
                            </p>
                            <div className="flex flex-row justify-center gap-4 lg:gap-8">
                                {item.btn1_text && (
                                    <a href={item.btn1_url} className="primary-button">{item.btn1_text}</a>
                                )}
                                {item.btn2_text && (
                                    <a href={item.btn2_url} className="primary-button">{item.btn2_text}</a>
                                )}
                            </div>
                        </div>
                    </div>
                </SwiperSlide>
            ))}
        </Swiper>
    );
}

export default Slider;
